uploadBar.$inject = [];

/**
 * @ngdoc    directive
 * @name     uploadBar
 * @memberof csm.ui.importForm
 * @require  importForm
 * @restrict E
 *
 * @description
 * This is an informational directive to be referenced by the importForm
 * directive. This correlates to a progress bar that will be shown during import.
 * As this is informational only, the element will be removed from the DOM.
 *
 * @attr {string}  id           Unique id to reference from the post back
 * @attr {string}  text         Text to display over bar
 * @attr {boolean} percentValue Indication to display a '%'
 *******************************************************************************/
/* @ngInject */
export function uploadBar() {
  return {
    restrict: 'E',
    require: '^^importForm',
    scope: { id: '@', text: '@', percentValue: '@' },
    link: function (scope, elem, attr, ctrl) {
      ctrl.addBarScope(scope);
      elem.remove();
      scope.$on('$destroy', function () {
        ctrl.removeBarScope(scope);
      });
    }
  };
}
